import { render, staticRenderFns } from "./PageBackground.vue?vue&type=template&id=a686fbae&scoped=true"
import script from "./PageBackground.vue?vue&type=script&lang=js"
export * from "./PageBackground.vue?vue&type=script&lang=js"
import style0 from "./PageBackground.vue?vue&type=style&index=0&id=a686fbae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a686fbae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a686fbae')) {
      api.createRecord('a686fbae', component.options)
    } else {
      api.reload('a686fbae', component.options)
    }
    module.hot.accept("./PageBackground.vue?vue&type=template&id=a686fbae&scoped=true", function () {
      api.rerender('a686fbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/PageBackground.vue"
export default component.exports